import React, { useCallback } from "react";

const ContextBridge = ({ children, contexts, render }) => {
  const nestContexts = useCallback((index, accumulatedChildren) => {
    if (index >= contexts.length) {
      return render(accumulatedChildren);
    }

    const { Context } = contexts[index];

    return (
      <Context.Consumer>
        {(value) =>
          nestContexts(
            index + 1,
            <Context.Provider value={value}>
              {accumulatedChildren}
            </Context.Provider>
          )
        }
      </Context.Consumer>
    );
  }, [contexts, render]);

  return nestContexts(0, children);
};

export default ContextBridge;
